export const SecbotServices = {
    all: [
      "677fc3a4d46fb00d2095ee09", // Broadcast Message Service (One Time)
      "677fc8c1d46fb00d2095eec5", // Broadcast Message (Three Time)  
      "677fc972d46fb00d2095eed6", // Button Ads Service (24 H)
      "677fcb14d46fb00d2095ef64", // Button Ads Service (72 H)
      "677fcb9cd46fb00d2095ef75", // Button Ads Service (1 Week)
      "677fcc02d46fb00d2095ef82", // Space Ad Service (X Spaces)
      "678f5f6ba7e7049dd035f66f", // Insider Alerts (1 Week Subscription)
      "678f5ef4a7e7049dd035f618", // Insider Alerts (1 Month Subscription)
      "67c1ca6da2cd8a54dd2b4ef2", // Telegram Premium Subscription ( ⁠6-Month )
      "67c1cc1da2cd8a54dd2b4f63", // Telegram Premium Subscription ( 12-Month )
      "67c5ff32a2cd8a54dd2b9ff9", // 1 video + Twitter Post
      "67e31fdf65f441311dfae41e", // 12-Months Premium
      "67e429c165f441311dfbcc70", // 12-Months Premium Plus
      "67e4685965f441311dfc2438" // Morph AI API
    ],
    NonSecbotAlertProducts: [
      "677fc3a4d46fb00d2095ee09", // Broadcast Message Service (One Time)
      "677fc8c1d46fb00d2095eec5", // Broadcast Message (Three Time)
      "677fc972d46fb00d2095eed6", // Button Ads Service (24 H)
      "677fcb14d46fb00d2095ef64", // Button Ads Service (72 H)
      "677fcb9cd46fb00d2095ef75", // Button Ads Service (1 Week)
      "677fcc02d46fb00d2095ef82", // Space Ad Service (X Spaces)
      "67c5ff32a2cd8a54dd2b9ff9", // 1 video + Twitter Post
      "67e4685965f441311dfc2438" // Morph AI API
    ],
    categories: {
      SecbotAlertProducts: [
        "678f5f6ba7e7049dd035f66f", // Insider Alerts (1 Week Subscription)
        "678f5ef4a7e7049dd035f618", // Insider Alerts (1 Month Subscription)
        "67c1ca6da2cd8a54dd2b4ef2", // Telegram Premium Subscription ( ⁠6-Month )
        "67c1cc1da2cd8a54dd2b4f63", // Telegram Premium Subscription ( 12-Month )
        "67e31fdf65f441311dfae41e", // 12-Months Premium
        "67e429c165f441311dfbcc70", // 12-Months Premium Plus
        "6840355c9227e6f953a453b8", // cg listing
        "684035a99227e6f953a45412", // cg trending
      ],
      xpremium: [
        "67e31fdf65f441311dfae41e", // 12-Months Premium
        "67e429c165f441311dfbcc70", // 12-Months Premium Plus
      ],
    },
  };
  